var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrafanaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#f15a28",
    d: "M 65.5,-0.5 C 66.5,-0.5 67.5,-0.5 68.5,-0.5C 73.4073,2.91517 77.074,7.41517 79.5,13C 83.5962,13.8572 87.5962,15.0238 91.5,16.5C 103.805,9.95172 109.305,13.6184 108,27.5C 112.188,31.8807 115.354,36.8807 117.5,42.5C 114.5,42.5 111.5,42.5 108.5,42.5C 95.2502,28.3528 79.2502,24.1862 60.5,30C 53.8339,32.5038 48.5006,36.6704 44.5,42.5C 35.8333,42.5 27.1667,42.5 18.5,42.5C 15.8503,35.796 14.8503,28.796 15.5,21.5C 24.0445,18.932 32.5445,18.932 41,21.5C 45.1386,18.5137 49.6386,16.1804 54.5,14.5C 57.0564,8.62118 60.723,3.62118 65.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#f15f27",
    d: "M 18.5,42.5 C 27.1667,42.5 35.8333,42.5 44.5,42.5C 43.2485,44.0009 42.2485,45.6675 41.5,47.5C 34.8333,46.1667 28.1667,46.1667 21.5,47.5C 20.2485,45.9991 19.2485,44.3325 18.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.826
    },
    fill: "#f16027",
    d: "M 108.5,42.5 C 111.5,42.5 114.5,42.5 117.5,42.5C 118.345,43.6715 119.011,45.0048 119.5,46.5C 117.05,46.298 114.717,46.6314 112.5,47.5C 111.197,45.8577 109.864,44.1911 108.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.774
    },
    fill: "#f26127",
    d: "M 91.5,46.5 C 84.1667,46.5 76.8333,46.5 69.5,46.5C 72.886,45.0296 76.5527,44.3629 80.5,44.5C 84.4473,44.3629 88.114,45.0296 91.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#f26526",
    d: "M 41.5,47.5 C 41.1667,48.1667 40.8333,48.8333 40.5,49.5C 34.1667,49.5 27.8333,49.5 21.5,49.5C 21.5,48.8333 21.5,48.1667 21.5,47.5C 28.1667,46.1667 34.8333,46.1667 41.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.926
    },
    fill: "#f26526",
    d: "M 69.5,46.5 C 76.8333,46.5 84.1667,46.5 91.5,46.5C 93.8185,46.9925 95.8185,47.9925 97.5,49.5C 86.5,49.5 75.5,49.5 64.5,49.5C 65.6594,47.7497 67.326,46.7497 69.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.842
    },
    fill: "#f26526",
    d: "M 119.5,46.5 C 119.557,47.609 119.89,48.609 120.5,49.5C 118.265,49.2053 116.265,49.5386 114.5,50.5C 113.599,49.7095 112.932,48.7095 112.5,47.5C 114.717,46.6314 117.05,46.298 119.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.958
    },
    fill: "#f26825",
    d: "M 21.5,49.5 C 27.8333,49.5 34.1667,49.5 40.5,49.5C 39.8902,50.391 39.5569,51.391 39.5,52.5C 33.1667,52.5 26.8333,52.5 20.5,52.5C 20.2627,51.209 20.596,50.209 21.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.957
    },
    fill: "#f26825",
    d: "M 64.5,49.5 C 75.5,49.5 86.5,49.5 97.5,49.5C 99.4044,49.7376 100.738,50.7376 101.5,52.5C 87.8333,52.5 74.1667,52.5 60.5,52.5C 61.795,51.5116 63.1283,50.5116 64.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.858
    },
    fill: "#f26825",
    d: "M 120.5,49.5 C 120.5,50.5 120.5,51.5 120.5,52.5C 118.833,52.5 117.167,52.5 115.5,52.5C 114.662,52.1583 114.328,51.4916 114.5,50.5C 116.265,49.5386 118.265,49.2053 120.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#f36d23",
    d: "M 20.5,52.5 C 26.8333,52.5 33.1667,52.5 39.5,52.5C 38.9759,54.3057 38.3092,55.9724 37.5,57.5C 31.5,57.5 25.5,57.5 19.5,57.5C 19.2155,55.5853 19.5489,53.9187 20.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#f36d23",
    d: "M 60.5,52.5 C 74.1667,52.5 87.8333,52.5 101.5,52.5C 103.167,53.5 104.5,54.8333 105.5,56.5C 99.3554,57.4902 93.0221,57.8235 86.5,57.5C 81.1464,54.9589 75.813,54.9589 70.5,57.5C 66.1667,57.5 61.8333,57.5 57.5,57.5C 58.075,55.5887 59.075,53.922 60.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.781
    },
    fill: "#f36d23",
    d: "M 115.5,52.5 C 117.167,52.5 118.833,52.5 120.5,52.5C 121.301,54.0418 121.634,55.7085 121.5,57.5C 120.167,57.5 118.833,57.5 117.5,57.5C 116.463,56.0697 115.796,54.403 115.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.898
    },
    fill: "#f37322",
    d: "M 105.5,56.5 C 107.063,57.9448 108.396,59.6115 109.5,61.5C 103.833,61.5 98.1667,61.5 92.5,61.5C 90.4632,60.1535 88.4632,58.8202 86.5,57.5C 93.0221,57.8235 99.3554,57.4902 105.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#f37322",
    d: "M 19.5,57.5 C 25.5,57.5 31.5,57.5 37.5,57.5C 37.5,58.8333 37.5,60.1667 37.5,61.5C 31.1667,61.5 24.8333,61.5 18.5,61.5C 18.2322,59.901 18.5655,58.5676 19.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.892
    },
    fill: "#f37322",
    d: "M 57.5,57.5 C 61.8333,57.5 66.1667,57.5 70.5,57.5C 68.8577,58.803 67.1911,60.1363 65.5,61.5C 62.1667,61.5 58.8333,61.5 55.5,61.5C 55.6596,59.847 56.3263,58.5137 57.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.719
    },
    fill: "#f37322",
    d: "M 117.5,57.5 C 118.833,57.5 120.167,57.5 121.5,57.5C 121.5,59.1667 121.5,60.8333 121.5,62.5C 118.53,62.2542 117.197,60.5876 117.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#f47a20",
    d: "M 18.5,61.5 C 24.8333,61.5 31.1667,61.5 37.5,61.5C 36.6586,63.3792 36.3253,65.3792 36.5,67.5C 27.8333,67.5 19.1667,67.5 10.5,67.5C 12.4426,64.5293 15.1092,62.5293 18.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#f47920",
    d: "M 55.5,61.5 C 58.8333,61.5 62.1667,61.5 65.5,61.5C 64.8333,63.1667 64.1667,64.8333 63.5,66.5C 60.5,66.5 57.5,66.5 54.5,66.5C 54.366,64.7085 54.6993,63.0418 55.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.923
    },
    fill: "#f47920",
    d: "M 92.5,61.5 C 98.1667,61.5 103.833,61.5 109.5,61.5C 110.167,63.1667 110.833,64.8333 111.5,66.5C 106.5,66.5 101.5,66.5 96.5,66.5C 94.9373,65.0552 93.604,63.3885 92.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#f4801e",
    d: "M 10.5,67.5 C 19.1667,67.5 27.8333,67.5 36.5,67.5C 36.5,68.8333 36.5,70.1667 36.5,71.5C 26.5,71.5 16.5,71.5 6.5,71.5C 7.5,69.8333 8.83333,68.5 10.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.934
    },
    fill: "#f47f1e",
    d: "M 54.5,66.5 C 57.5,66.5 60.5,66.5 63.5,66.5C 62.6993,68.0418 62.366,69.7085 62.5,71.5C 59.8333,71.5 57.1667,71.5 54.5,71.5C 54.5,69.8333 54.5,68.1667 54.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.927
    },
    fill: "#f47f1e",
    d: "M 96.5,66.5 C 101.5,66.5 106.5,66.5 111.5,66.5C 112.038,68.1172 112.371,69.7839 112.5,71.5C 107.637,71.1805 102.97,71.5139 98.5,72.5C 97.5418,70.6976 96.8751,68.6976 96.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.97
    },
    fill: "#f5861c",
    d: "M 6.5,71.5 C 16.5,71.5 26.5,71.5 36.5,71.5C 37.4511,72.9187 37.7845,74.5853 37.5,76.5C 26.5,76.5 15.5,76.5 4.5,76.5C 4.89254,74.7162 5.5592,73.0495 6.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.892
    },
    fill: "#f5861d",
    d: "M 54.5,71.5 C 57.1667,71.5 59.8333,71.5 62.5,71.5C 62.5,73.1667 62.5,74.8333 62.5,76.5C 60.1667,76.5 57.8333,76.5 55.5,76.5C 54.5489,75.0813 54.2155,73.4147 54.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#f5861c",
    d: "M 112.5,71.5 C 113.038,73.1172 113.371,74.7839 113.5,76.5C 108.5,76.5 103.5,76.5 98.5,76.5C 98.5,75.1667 98.5,73.8333 98.5,72.5C 102.97,71.5139 107.637,71.1805 112.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#f58c1b",
    d: "M 4.5,76.5 C 15.5,76.5 26.5,76.5 37.5,76.5C 38.3446,77.6715 39.0113,79.0048 39.5,80.5C 27.4197,80.1881 15.4197,80.5214 3.5,81.5C 2.32167,79.6621 2.655,77.9955 4.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "#f58c1b",
    d: "M 55.5,76.5 C 57.8333,76.5 60.1667,76.5 62.5,76.5C 63.4884,77.795 64.4884,79.1283 65.5,80.5C 62.7212,80.2786 60.0545,80.612 57.5,81.5C 56.0582,80.1805 55.3915,78.5138 55.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94
    },
    fill: "#f58c1b",
    d: "M 98.5,76.5 C 103.5,76.5 108.5,76.5 113.5,76.5C 113.5,77.8333 113.5,79.1667 113.5,80.5C 108.5,80.5 103.5,80.5 98.5,80.5C 98.5,79.1667 98.5,77.8333 98.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.96
    },
    fill: "#f6911a",
    d: "M 39.5,80.5 C 40.4408,82.0495 41.1075,83.7162 41.5,85.5C 30.5,85.5 19.5,85.5 8.5,85.5C 6.24602,84.8763 4.57935,83.543 3.5,81.5C 15.4197,80.5214 27.4197,80.1881 39.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.777
    },
    fill: "#f69219",
    d: "M 65.5,80.5 C 70.2229,84.427 75.5563,85.427 81.5,83.5C 82.7133,83.7472 83.38,84.4138 83.5,85.5C 76.1667,85.5 68.8333,85.5 61.5,85.5C 59.8333,84.5 58.5,83.1667 57.5,81.5C 60.0545,80.612 62.7212,80.2786 65.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#f69219",
    d: "M 98.5,80.5 C 103.5,80.5 108.5,80.5 113.5,80.5C 114.075,82.4113 115.075,84.078 116.5,85.5C 109.833,85.5 103.167,85.5 96.5,85.5C 97.0241,83.6943 97.6908,82.0276 98.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#f69618",
    d: "M 8.5,85.5 C 19.5,85.5 30.5,85.5 41.5,85.5C 42.1667,85.5 42.5,85.8333 42.5,86.5C 32.2487,87.475 21.9154,87.8083 11.5,87.5C 9.97306,87.573 8.97306,86.9063 8.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.895
    },
    fill: "#f69618",
    d: "M 61.5,85.5 C 68.8333,85.5 76.1667,85.5 83.5,85.5C 83.0269,86.9063 82.0269,87.573 80.5,87.5C 75.5,87.5 70.5,87.5 65.5,87.5C 63.847,87.3404 62.5137,86.6737 61.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#f79618",
    d: "M 96.5,85.5 C 103.167,85.5 109.833,85.5 116.5,85.5C 117.167,85.5 117.5,85.8333 117.5,86.5C 110.401,87.8099 103.401,87.8099 96.5,86.5C 96.5,86.1667 96.5,85.8333 96.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.928
    },
    fill: "#f79917",
    d: "M 42.5,86.5 C 43.5,87.8333 44.5,89.1667 45.5,90.5C 36.6506,90.1736 27.9839,90.507 19.5,91.5C 16.2459,91.2064 13.5792,89.873 11.5,87.5C 21.9154,87.8083 32.2487,87.475 42.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#f79917",
    d: "M 96.5,86.5 C 103.401,87.8099 110.401,87.8099 117.5,86.5C 118.234,87.7079 118.567,89.0413 118.5,90.5C 110.5,90.5 102.5,90.5 94.5,90.5C 94.6596,88.847 95.3263,87.5137 96.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.717
    },
    fill: "#f79917",
    d: "M 65.5,87.5 C 70.5,87.5 75.5,87.5 80.5,87.5C 78.5379,89.0173 76.2046,89.6839 73.5,89.5C 70.5143,89.6183 67.8476,88.9517 65.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.923
    },
    fill: "#f79f16",
    d: "M 45.5,90.5 C 47.5,91.8333 49.1667,93.5 50.5,95.5C 42.5,95.5 34.5,95.5 26.5,95.5C 24.551,93.437 22.2177,92.1036 19.5,91.5C 27.9839,90.507 36.6506,90.1736 45.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.946
    },
    fill: "#f79f16",
    d: "M 94.5,90.5 C 102.5,90.5 110.5,90.5 118.5,90.5C 119.339,91.6412 120.006,92.9745 120.5,94.5C 120.145,95.5223 119.478,96.189 118.5,96.5C 109.348,95.5064 100.015,95.1731 90.5,95.5C 91.1237,93.246 92.457,91.5794 94.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#f8a514",
    d: "M 26.5,95.5 C 34.5,95.5 42.5,95.5 50.5,95.5C 53.1667,96.8333 55.8333,98.1667 58.5,99.5C 49.3483,100.494 40.015,100.827 30.5,100.5C 28.457,99.4206 27.1237,97.754 26.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.935
    },
    fill: "#f8a514",
    d: "M 90.5,95.5 C 100.015,95.1731 109.348,95.5064 118.5,96.5C 114.777,98.6755 110.777,100.009 106.5,100.5C 98.9809,100.825 91.6476,100.492 84.5,99.5C 86.2228,97.7819 88.2228,96.4486 90.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#f8ab13",
    d: "M 58.5,99.5 C 67.1613,103.499 75.828,103.499 84.5,99.5C 91.6476,100.492 98.9809,100.825 106.5,100.5C 105.396,102.389 104.063,104.055 102.5,105.5C 79.3393,104.502 56.006,104.169 32.5,104.5C 32.2671,102.938 31.6005,101.605 30.5,100.5C 40.015,100.827 49.3483,100.494 58.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#f9b111",
    d: "M 32.5,104.5 C 56.006,104.169 79.3393,104.502 102.5,105.5C 101.167,107.5 99.5,109.167 97.5,110.5C 75.5,110.5 53.5,110.5 31.5,110.5C 31.3253,108.379 31.6586,106.379 32.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#f9b80f",
    d: "M 31.5,110.5 C 53.5,110.5 75.5,110.5 97.5,110.5C 96.032,111.779 95.3653,113.446 95.5,115.5C 74.2421,114.512 52.9088,114.178 31.5,114.5C 31.5,113.167 31.5,111.833 31.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#fabe0e",
    d: "M 31.5,114.5 C 52.9088,114.178 74.2421,114.512 95.5,115.5C 95.0113,116.995 94.3446,118.329 93.5,119.5C 86.5,119.5 79.5,119.5 72.5,119.5C 66.5551,119.763 60.7217,119.096 55,117.5C 53.415,118.044 51.915,118.711 50.5,119.5C 44.5,119.5 38.5,119.5 32.5,119.5C 31.5489,118.081 31.2155,116.415 31.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.909
    },
    fill: "#fbc20c",
    d: "M 32.5,119.5 C 38.5,119.5 44.5,119.5 50.5,119.5C 49.0697,120.537 47.403,121.204 45.5,121.5C 41.1667,121.5 36.8333,121.5 32.5,121.5C 32.5,120.833 32.5,120.167 32.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.948
    },
    fill: "#fbc20c",
    d: "M 72.5,119.5 C 79.5,119.5 86.5,119.5 93.5,119.5C 93.5,120.167 93.5,120.833 93.5,121.5C 87.1667,121.5 80.8333,121.5 74.5,121.5C 73.5,121.167 72.8333,120.5 72.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.647
    },
    fill: "#fbc50b",
    d: "M 32.5,121.5 C 36.8333,121.5 41.1667,121.5 45.5,121.5C 42.8954,122.592 40.062,123.259 37,123.5C 34.9919,123.693 33.4919,123.026 32.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.918
    },
    fill: "#fbc50b",
    d: "M 74.5,121.5 C 80.8333,121.5 87.1667,121.5 93.5,121.5C 92.8333,122.5 92.1667,123.5 91.5,124.5C 87.1667,124.5 82.8333,124.5 78.5,124.5C 76.5956,124.262 75.2623,123.262 74.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.813
    },
    fill: "#fbc90a",
    d: "M 78.5,124.5 C 82.8333,124.5 87.1667,124.5 91.5,124.5C 90.8333,125.5 90.1667,126.5 89.5,127.5C 86.8333,127.5 84.1667,127.5 81.5,127.5C 80.3065,126.728 79.3065,125.728 78.5,124.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrafanaIcon);
export default __webpack_public_path__ + "static/media/GrafanaIcon.4023e6217550b0aec4ba5fc651fd2b2a.svg";
export { ForwardRef as ReactComponent };